// Applicant List
// const application = 'adaim/assistive-device-applications/'
// export const applicantList = application + 'list'
const application = 'addadm/pending-demand-list/'
export const applicantList = application + 'list'
export const budgetDataList = application + 'budget-data'

// Distribution List api
const distributionListBaseUrl = 'addadm/distributed-list/'
export const distributionList = distributionListBaseUrl + 'list'
export const distributionListApplication = distributionListBaseUrl + 'show-application'
export const distributionListDistribute = distributionListBaseUrl + 'distribute'
export const distributionReceiptList = distributionListBaseUrl + 'receipt-list'
export const distributionReceiptAttachment = distributionListBaseUrl + 'attachment'

export const stockSummartReportApi = 'addadm/report/stock-summary-report'
export const reportHeadingList = '/configuration/report-heading/detail'

// Report Api
const report = 'addadm/report/'
export const purchasesAgainstDistributionReport = report + 'distribution-report'
export const devicrStockReport = report + 'device-stock-report'
export const assistiveDevicrStockReport = report + 'device-stock-report-demo'

// dashboard Api
export const dashboardData = 'addadm/dashboard/dashboard-data'
// PSOSK Requisition
export const StockOutRequisitionApproveList = 'adaim/stock-out-requisition/approvelist'
export const StockOutRequisitionUpdate = 'adaim/stock-out-requisition/update'
export const StockOutRequisitionApprove = 'adaim/stock-out-requisition/approve'
export const StockOutRequisitionDetails = 'adaim/stock-out-requisition/details'
export const StockOutRequisitionTotalStock = 'adaim/stock-out-requisition/totalstock'
// PSOSK Requisition
export const PSOSKRequisitionStore = 'addadm/psosk-requisition/store'
export const PSOSKRequisitionList = 'addadm/psosk-requisition/list'
export const PSOSKRequisitionApproveList = 'addadm/psosk-requisition/approvelist'
export const PSOSKRequisitionUpdate = 'addadm/psosk-requisition/update'
export const psoskFinalSave = 'addadm/psosk-requisition/final-save'
export const psoskDetailsApi = 'addadm/psosk-requisition/details'
export const psoskRequestedList = 'addadm/psosk-requisition/requested-list'
export const psoskAssignStore = 'addadm/psosk-requisition/assign-psosk-store'
export const psoskTransferStore = 'addadm/psosk-requisition/transfer-psosk-store'
export const psoskReceiveStore = 'addadm/psosk-requisition/receive-psosk-store'
export const psoskForwardedList = 'addadm/psosk-requisition/forwarded-list'
export const psoskForwardeRequisitionTotalStock = 'addadm/psosk-requisition/totalstock'
// export const StockOutRequisitionApprove = 'adaim/stock-out-requisition/approve'
// export const StockOutRequisitionDetails = 'adaim/stock-out-requisition/details'
// export const StockOutRequisitionTotalStock = 'adaim/stock-out-requisition/totalstock'
